import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import FramlLandingPage from '../pages/framl/landing/FramlLandingPage';
import NotFoundPage from '../pages/common/NotFoundPage';
import {
  getCanSeeFramlView,
  getClientConfigLoaded
} from '../redux/selectors/cm/access';
import { fetchDashboardBins } from '../redux/actions/cm/dashboard';

// FIN-14761: the resource check moved into getCanSeeFramlView (same resource as
// before — APP_7_RESOURCE_UI_CM_FRAML — now ANDed with the env kill switch that
// GET /cm/configs/client reports). The CM app loads that config in
// loadAppContext, but a direct /app/framl entry never mounts CMApp, so fetch it
// here too.
// Review F1/F3: while the config is pending the flag is unknown — show a
// spinner, not a denied flash; once resolved, a denied user gets NotFoundPage
// (the FIN-14761 denied UX) instead of a blank shell.
const FramlRoutes = ({ canSeeFramlView, clientConfigLoaded, dispatch }) => {
  useEffect(() => {
    dispatch(fetchDashboardBins());
  }, [dispatch]);

  if (!clientConfigLoaded) {
    return <Spin style={{ width: '100%', margin: '200px 0' }} delay={200} />;
  }

  return canSeeFramlView ? (
    <Switch>
      <Route exact path="/app/framl" component={FramlLandingPage} />
    </Switch>
  ) : (
    <NotFoundPage />
  );
};

FramlRoutes.propTypes = {
  canSeeFramlView: PropTypes.bool,
  clientConfigLoaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  canSeeFramlView: getCanSeeFramlView(state),
  clientConfigLoaded: getClientConfigLoaded(state)
});

export default connect(mapStateToProps)(FramlRoutes);
